import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-white border-t border-white/10">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <img src="/logo-full-light.png" alt="SA Webdesign – Modern. Individuell. Erfolgreich." className="h-24 w-auto" data-testid="footer-logo" />
          <p className="mt-4 text-sm text-white/50 leading-relaxed max-w-xs">
            Moderne Webseiten für lokale Unternehmen — persönlich betreut von Stephan Appenzeller.
          </p>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Kontakt</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="mailto:stephan@sa-webdesign.net" data-testid="footer-email" className="flex items-center gap-2.5 text-white/75 hover:text-white transition-colors duration-200">
                <Mail className="w-4 h-4 text-[#60A5FA]" aria-hidden="true" />
                stephan@sa-webdesign.net
              </a>
            </li>
            <li>
              <a href="tel:+4916094869112" data-testid="footer-phone" className="flex items-center gap-2.5 text-white/75 hover:text-white transition-colors duration-200">
                <Phone className="w-4 h-4 text-[#60A5FA]" aria-hidden="true" />
                +49 160 94869112
              </a>
            </li>
            <li className="flex items-center gap-2.5 text-white/75">
              <MapPin className="w-4 h-4 text-[#60A5FA]" aria-hidden="true" />
              Bahnstr. 19, 40878 Ratingen
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Navigation</p>
          <ul className="space-y-3 text-sm">
            {[
              ["#leistungen", "Leistungen"],
              ["#referenzen", "Referenzen"],
              ["#prozess", "Prozess"],
              ["#kontakt", "Kontakt"],
            ].map(([href, label]) => (
              <li key={href}>
                <a href={href} className="text-white/75 hover:text-white transition-colors duration-200">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-xs text-white/35">© {new Date().getFullYear()} SA Webdesign · Stephan Appenzeller</p>
          <div className="flex gap-6 text-xs text-white/35">
            <a href="/impressum" data-testid="footer-impressum-link" className="hover:text-white/70 transition-colors duration-200">Impressum</a>
            <a href="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-white/70 transition-colors duration-200">Datenschutz</a>
            <a href="/agb" data-testid="footer-agb-link" className="hover:text-white/70 transition-colors duration-200">AGB</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
